import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { AdminPermissionModel } from '../../models/AdminPermissionModel';

interface IAdminPermissionsService {
  getPrincipalPermissions: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<AdminPermissionModel>>;
}

export const adminPermissionService: IAdminPermissionsService = {
  getPrincipalPermissions(axiosConfig) {
    return ajax.get<AdminPermissionModel>(
      `${config.benefitApiUrl}/permissions`,
      axiosConfig,
    );
  },
};
